
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-mx/ia/programacion-de-andenes",
      function () {
        return require("private-next-pages/es-mx/ia/programacion-de-andenes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-mx/ia/programacion-de-andenes"])
      });
    }
  